import groupsSaga from './groupsSaga';

export default groupsSaga;
